import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { LfaContextAPIShape } from '../../../Context/LfaContext';
import Utils from '../../../Services/Utils';
import History from '../../../Services/History';

import { TextWidget } from '../../DynamicFormBuilderScreen/Widgets/Text';
import { PhoneWidget } from '../../DynamicFormBuilderScreen/Widgets/Phone';
import { NumberWidget } from '../../DynamicFormBuilderScreen/Widgets/Number';
import { CurrencyWidget } from '../../DynamicFormBuilderScreen/Widgets/Currency';
import { CheckboxWidget } from '../../DynamicFormBuilderScreen/Widgets/Checkbox';
import { RadioWidget } from '../../DynamicFormBuilderScreen/Widgets/Radio';
import { SelectWidget } from '../../DynamicFormBuilderScreen/Widgets/Select';
import { TextAreaWidget } from '../../DynamicFormBuilderScreen/Widgets/TextArea';
import { DateTimeWidget } from '../../DynamicFormBuilderScreen/Widgets/DateTime';
import { DateWidget } from '../../DynamicFormBuilderScreen/Widgets/Date';
import { TimeWidget } from '../../DynamicFormBuilderScreen/Widgets/Time';
import { FileWidget } from '../../DynamicFormBuilderScreen/Widgets/File';
import { PhotoWidget } from '../../DynamicFormBuilderScreen/Widgets/Photo';
import { MultiplePhotoWidget } from '../../DynamicFormBuilderScreen/Widgets/MultiplePhoto';
import { SignatureWidget } from '../../DynamicFormBuilderScreen/Widgets/Signature';
import { SliderRangeWidget } from '../../DynamicFormBuilderScreen/Widgets/SliderRange';
import { StarsWidget } from '../../DynamicFormBuilderScreen/Widgets/Stars';
import { UserNameWidget } from '../../DynamicFormBuilderScreen/Widgets/UserName';
import { PropertyNameWidget } from '../../DynamicFormBuilderScreen/Widgets/PropertyName';
import { PropertyAddressWidget } from '../../DynamicFormBuilderScreen/Widgets/PropertyAddress';
import { PropertyInfoWidget } from '../../DynamicFormBuilderScreen/Widgets/PropertyInfo';
import { UnitInfoWidget } from '../../DynamicFormBuilderScreen/Widgets/UnitInfo';
import { UnitBuildingWidget } from '../../DynamicFormBuilderScreen/Widgets/UnitBuilding';
import { UnitNumberWidget } from '../../DynamicFormBuilderScreen/Widgets/UnitNumber';
import { FileEmbeddedWidget } from '../../DynamicFormBuilderScreen/Widgets/FileEmbedded';
import { PageBreakWidget } from '../../DynamicFormBuilderScreen/Widgets/PageBreak';
import { FormDescriptionWidget } from '../../DynamicFormBuilderScreen/Widgets/FormDescription';
import ModalFieldNote from '../ModalFieldNote';
import ModalFieldPhoto from '../ModalFieldPhoto';
import { FileImageWidget } from '../../DynamicFormBuilderScreen/Widgets/FileImage';
import {Rating3ptWidget} from '../../DynamicFormBuilderScreen/Widgets/Rating3pt'

class CustomDynamicFormsFieldComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalPhotoVisible: false,
      modalNoteVisible: false,
      error: this.props.error,
      errorTrigger: this.props.errorTrigger
    };
  }

  componentDidMount() {
    History.singleton().register(
      'modalPhoto',
      () => {
        this.onPressedPhoto();
      },
      () => {
        this.onModalPhotoClose();
      }
    );
    History.singleton().register(
      'modalNote',
      () => {
        this.onPressedNote();
      },
      () => {
        this.onModalNoteClose();
      }
    );
  }

  componentWillUnmount() {
    History.singleton().unregister('modalPhoto');
    History.singleton().unregister('modalNote');
  }

  onPressedPhoto = () => {
    History.singleton().show('modalPhoto');
    this.setState({ modalPhotoVisible: true });
  };

  onPressedNote = () => {
    History.singleton().show('modalNote');
    this.setState({ modalNoteVisible: true });
  };

  onModalPhotoClose = (event) => {
    History.singleton().close(event);
    this.setState({ modalPhotoVisible: false });
  };

  onModalNoteClose = (event) => {
    History.singleton().close(event);
    this.setState({ modalNoteVisible: false });
  };

  getView = () => {
    const { descriptionAsIcon, showTriggerConditionMet, isCompact, configuration, data, api, onPressedWorkOrder, fieldsError } = this.props;

    if (!this.isFieldVisible()) {
      configuration.disabled = true;
      configuration.component = 'textInput';
      configuration.required = false;
      configuration.placeholder = '';
      fieldsError.sections[configuration.section].fields[configuration.id] = null;
    }

    const commonProps = {
      label: configuration.label,
      value: data.value,
      onChange: (value) => api.onFieldValueChange(configuration.section, configuration.id, value),
      onChangeTrigger: (value) => api.onFieldTriggerChange(configuration.section, configuration.id, value),
      onError: (error) => this.setFieldError(error),
      onErrorTrigger: (errorTrigger) => this.setFieldErrorTrigger(errorTrigger),
      configuration,
      data,
      error: fieldsError.sections[configuration.section].fields[configuration.id],
      errorTrigger: fieldsError.sections[configuration.section].fields[configuration.id + 'trigger'],
      api,
      isDisabled: true,
      field: configuration,
      descriptionAsIcon: descriptionAsIcon,
      showTriggerConditionMet: showTriggerConditionMet,
      isCompact: isCompact,
      handleClickAttachment: this.onPressedPhoto,
      handleClickNote: this.onPressedNote,
      handleClickWorkOrder: onPressedWorkOrder
    };

    switch (configuration.component) {
      case 'textInput':
        return <TextWidget {...commonProps} />;
      case 'phoneInput':
        return <PhoneWidget {...commonProps} />;
      case 'numberInput':
        return <NumberWidget {...commonProps} />;
      case 'currencyInput':
        return <CurrencyWidget {...commonProps} />;
      case 'checkbox':
      case 'checkboxJustifiedLeft':
        return <CheckboxWidget {...commonProps} options={configuration.options} />;
      case 'radio':
      case 'radioJustifiedLeft':
        return (
          <RadioWidget
            {...commonProps}
            options={configuration.options}
            onChange={(n, value) => api.onFieldValueChange(configuration.section, configuration.id, value)}
          />
        );
      case 'select':
        return <SelectWidget
            {...commonProps}
            onChange={({ value }) => api.onFieldValueChange(configuration.section, configuration.id, value)}
        />;
      case 'textArea':
        return <TextAreaWidget {...commonProps} />;
      case 'dateTimeInput':
        return <DateTimeWidget {...commonProps} />;
      case 'dateInput':
        return <DateWidget {...commonProps} />;
      case 'timeInput':
        return <TimeWidget {...commonProps} />;
      case 'fileImageInput':
        return <FileImageWidget {...commonProps} />;
      case 'fileInput':
        return <FileWidget {...commonProps} />;
      case 'imageInput':
        return <PhotoWidget {...commonProps} />;
      case 'imageMultipleInput':
        return <MultiplePhotoWidget {...commonProps} />;
      case 'signatureInput':
        return <SignatureWidget {...commonProps} />;
      case 'sliderRange':
        return <SliderRangeWidget {...commonProps} />;
      case 'starRate':
        return <StarsWidget {...commonProps} />;
      case 'userName':
        return <UserNameWidget {...commonProps} />;
      case 'propertyName':
        return <PropertyNameWidget {...commonProps} />;
      case 'propertyAddress':
        return <PropertyAddressWidget {...commonProps} />;
      case 'propertyInfo':
        return <PropertyInfoWidget {...commonProps} />;
      case 'unitInfo':
        return <UnitInfoWidget {...commonProps} />;
      case 'unitBuilding':
        return <UnitBuildingWidget {...commonProps} />;
      case 'unitNumber':
        return <UnitNumberWidget {...commonProps} />;
      case 'fileEmbedded':
        return <FileEmbeddedWidget {...commonProps} />;
      case 'pageBreak':
        return <PageBreakWidget {...commonProps} />;
      case 'freeText':
        return <FormDescriptionWidget {...commonProps} />;
      case 'ratingScale3pt':
              return (
                <Rating3ptWidget
                  {...commonProps}
                  options={configuration.options}
                  onChange={(n, value) => api.onFieldValueChange(configuration.section, configuration.id, value)}
                />
              );
      default:
        return <div />;
    }
  };

  isFieldVisible = () => {
    const { configuration, data } = this.props;

    if (data.visibility === false) {
      return false;
    }

    const visibleComponents = [
      'textInput',
      'phoneInput',
      'numberInput',
      'currencyInput',
      'checkbox',
      'checkboxJustifiedLeft',
      'radio',
      'radioJustifiedLeft',
      'select',
      'textArea',
      'phoneInput',
      'dateTimeInput',
      'dateInput',
      'timeInput',
      'fileImageInput',
      'fileInput',
      'imageInput',
      'imageMultipleInput',
      'signatureInput',
      'sliderRange',
      'starRate',
      'userName',
      'unitNumber',
      'propertyName',
      'propertyAddress',
      'propertyInfo',
      'unitInfo',
      'unitBuilding',
      'fileEmbedded',
      'freeText',
      'pageBreak',
      'ratingScale3pt'
    ];
    if (visibleComponents.indexOf(configuration.component) === -1) {
      return false;
    }

    if (configuration.component === 'fileEmbedded') {
      return !Utils.isEmpty(configuration.embedded);
    }
    return data.visibility;
  };

  addField = (ref) => {
    this.props.onFieldAdded(this.props.configuration.id, ref);
  };

  setFieldError = (newError) => {
    const { configuration, error, sectionId, fieldsError } = this.props;
    if (!Utils.equals(newError, error)) {
      fieldsError.sections[sectionId].fields[configuration.id] = newError;
      this.setState({
        error: newError
      });
    }
  };

  setFieldErrorTrigger = (newErrorTrigger) => {
    const { configuration, errorTrigger, sectionId, fieldsError } = this.props;
    if (!Utils.equals(newErrorTrigger, errorTrigger)) {
      fieldsError.sections[sectionId].fields[configuration.id + 'trigger'] = newErrorTrigger;
      this.setState({
        errorTrigger: newErrorTrigger
      });
    }
  };

  setFieldRequired = () => {
    const { configuration, entityType } = this.props;
    //Guarantor -> 2
    //Minor -> 3
    //Corporate -> 4

    if (['Current Renters Insurance in File?'].includes(configuration.label)) {
      if ([2, 3].includes(entityType)) {
        if (configuration.required) configuration.required = false;
      } else {
        if (!configuration.required) configuration.required = true;
      }
    } else if (['ZIP Code Moved From', 'Criminal Check'].includes(configuration.label)) {
      if ([2, 3, 4].includes(entityType)) {
        if (configuration.required) configuration.required = false;
      } else {
        if (!configuration.required) configuration.required = true;
      }
    } else if (
      ['Employer Name', 'Occupation', 'Income Amount', 'Income Frequency', 'Proof of Income', 'Credit Check', '2nd Source of Income?'].includes(
        configuration.label
      )
    ) {
      if ([3, 4].includes(entityType)) {
        if (configuration.required) configuration.required = false;
      } else {
        if (!configuration.required) configuration.required = true;
      }
    }
  };

  render() {
    const { configuration, data, api, isCompact } = this.props;

    this.setFieldRequired();

    return (
      <div
        className={classNames('WrapperSection_Field', {
          WrapperSection_Field_Compact: Boolean(isCompact),
          'WrapperSection_Field_Compact--disabled': !this.isFieldVisible()
        })}
        ref={this.addField}
        id={configuration.id}>
        {this.getView()}
        {this.state.modalPhotoVisible && <ModalFieldPhoto configuration={configuration} data={data} api={api} onClose={this.onModalPhotoClose} />}
        {this.state.modalNoteVisible && <ModalFieldNote configuration={configuration} data={data} api={api} onClose={this.onModalNoteClose} />}
      </div>
    );
  }
}

CustomDynamicFormsFieldComponent.propTypes = {
  configuration: PropTypes.object.isRequired,
  descriptionAsIcon: PropTypes.bool,
  showTriggerConditionMet: PropTypes.bool,
  isCompact: PropTypes.bool,
  data: PropTypes.object.isRequired,
  error: PropTypes.string,
  errorTrigger: PropTypes.string,
  api: LfaContextAPIShape,
  onPressedWorkOrder: PropTypes.func.isRequired
};

export default CustomDynamicFormsFieldComponent;
